/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HomeyStatus } from './homey-status';
import { IgnoredReason } from './ignored-reason';


export interface UserOverviewDto { 
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    lastSeen: string;
    householdSize: number;
    status: HomeyStatus;
    paymentStatus: UserOverviewDto.PaymentStatusEnum;
    createdAt: string;
    ignoredReason: IgnoredReason;
    lotteryNotifications: boolean;
    ignore: boolean;
    rentalAssistance: boolean;
    lastSyncStatus?: string;
    lastSyncError?: string;
}
export namespace UserOverviewDto {
    export const PaymentStatusEnum = {
        paid: 'paid',
        not_paid: 'not-paid'
    } as const;
    export type PaymentStatusEnum = typeof PaymentStatusEnum[keyof typeof PaymentStatusEnum];
}


